import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
var text = colorUseCases.text;
export default css({
  fontFamily: "$body",
  fontWeight: "$body",
  fontSize: "$body",
  lineHeight: "$body",
  color: getColorScaleValueByUseCase("grey", text.lowContrast),
  whiteSpace: "nowrap"
});